import { gql } from '@apollo/client';

export const ProductListingFragment = gql`
    fragment ProductListingFragment on Cart {
        id
        items {
            id
            # lightr ifmodule 'YoungDogs_ConfiguratorGraphQl' #
            custom_price
            options
            # lightr endifmodule #
            product {
                id
                name
                sku
                url_key
                url_suffix
                thumbnail {
                    url
                }
                small_image {
                    url
                }
                stock_status
            }
            prices {
                #  total_item_discount {
                #    value
                #  }
                price {
                    currency
                    value
                }
                price_including_tax {
                    currency
                    value
                }
            }
            quantity
            ... on ConfigurableCartItem {
                configurable_options {
                    id
                    option_label
                    value_id
                    value_label
                }
            }
            ... on BundleCartItem {
                bundle_options {
                    id
                    label
                    values {
                        id
                        label
                        price
                        quantity
                    }
                }
            }
        }
    }
`;
